import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  padding: ${({ theme }) => theme.constants.lateralSpace};
  padding-bottom: 0;
  background: ${({ theme }) => theme.colors.white};
  img {
    margin: 2px;
  }
`;

// eslint-disable-next-line react/prop-types
function NutritionalLabels({ nutritionInfo }) {
  // eslint-disable-next-line react/prop-types
  const images = nutritionInfo?.frontLabels?.map(n => (
    <img key={n.image} src={n.image} width="50px" height="50px" />
  ));

  return <Container>{images}</Container>;
}

NutritionalLabels.propTypes = {
  nutritionInfo: PropTypes.object,
};

export default NutritionalLabels;
